import Home from './components/Home.vue';
import News from './components/News.vue';
import Details from './components/Details.vue';
import About from './components/About.vue';
import Contact from './components/Contact.vue';
import Marketing from './components/Marketing.vue';
import ExchangeRates from './components/ExchangeRates.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import Impressum from './components/Impressum.vue';
import ReportNews from './components/ReportNews.vue';

export const routes = [
    { path: '/', component: Home },
    { path: '/:category/:subcategory?', name: 'category', component: News },
    { path: '/:category/:slug/:id', name: 'read', component: Details},
    { path: '/o-nama', name: 'o-nama', component: About},
    { path: '/kontakt', name:'kontakt', component: Contact},
    { path: '/marketing', name: 'marketing', component: Marketing},
    { path: '/kursna-lista', name:'kursna-lista', component: ExchangeRates},
    { path: '/pravila-privatnosti', name: 'pravila-privatnosti', component: PrivacyPolicy},
    { path: '/impressum', name: 'impressum', component: Impressum},
    { path: '/dojavi-vijest', name: 'dojavi-vijest', component: ReportNews},
    { path: '*', component: Home },
];





// WEBPACK FOOTER //
// ./src/routes.js